import React from 'react'

import '@reach/tabs/styles.css'

import * as S from './Tabs.styles'
import { TabProps } from './Tabs.types'

const NewTab = ({
  as,
  children,
  disabled,
  ...props
}: TabProps & React.ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => {
  return (
    <S.TabStyled as={as} disabled={disabled} {...props}>
      {children}
      <S.CustomSelectOption />
    </S.TabStyled>
  )
}

export {
  TabListStyled as TabList,
  TabPanelStyled as TabPanel,
  TabPanelsStyled as TabPanels,
  TabsStyled as Tabs,
} from './Tabs.styles'

export { NewTab as Tab }
